export const PROCEDURE_STATUS_BOOKED = 'booked';
export const PROCEDURE_STATUS_COMPLETED = 'completed';
export const PROCEDURE_STATUS_CANCELLED = 'cancelled';
export const PROCEDURE_STATUS_NO_SHOW = 'no show';
export const PROCEDURE_STATUS_ABORTED = 'aborted';

export const PROCEDURE_STATUS__VALUES = [
  PROCEDURE_STATUS_BOOKED,
  PROCEDURE_STATUS_COMPLETED,
  PROCEDURE_STATUS_CANCELLED,
  PROCEDURE_STATUS_NO_SHOW,
  PROCEDURE_STATUS_ABORTED,
];
